import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useUserContext } from "../contexts/UserContext";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { API_URL } from '../config/api';


export default function AchatsDepenses() {
  const { user } = useUserContext();
  const [list, setList] = useState([]);
  const [form, setForm] = useState({
    type: "DEPENSE",
    categorie: "AUTRE",
    montant: "",
    description: ""
  });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);

  const [editForm, setEditForm] = useState({
    type: "",
    categorie: "",
    montant: "",
    description: ""
  });

  const openEditModal = depense => {
    setSelected(depense);
    setEditForm({
      type: depense.type,
      categorie: depense.categorie,
      montant: depense.montant,
      description: depense.description || ""
    });
    setShowEditModal(true);
  };

  const openDeleteModal = depense => {
    setSelected(depense);
    setShowDeleteModal(true);
  };

  const handleUpdate = async e => {
    e.preventDefault();
    const res = await fetch(
      `${API_URL}/update/depense/achat/${selected._id}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(editForm)
      }
    );

    if (!res.ok) return toast.error("Erreur mise à jour");

    toast.success("Dépense mise à jour");
    setShowEditModal(false);
    fetchData();
  };

  const [page, setPage] = useState(1);
  const perPage = 5;

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const fetchData = async () => {
    const res = await fetch(
      `http://localhost:8000/depense/achat?adminId=${user._id}`
    );
    const data = await res.json();
    setList(data);
  };

  useEffect(() => {
    if (user?._id) fetchData();
  }, [user]);

  const filteredList = list.filter(d => {
    const date = new Date(d.createdAt);

    if (from) {
      const fromDate = new Date(from);
      fromDate.setHours(0, 0, 0, 0);
      if (date < fromDate) return false;
    }

    if (to) {
      const toDate = new Date(to);
      toDate.setHours(23, 59, 59, 999);
      if (date > toDate) return false;
    }

    return true;
  });

  const submit = async e => {
    e.preventDefault();
    const res = await fetch("http://localhost:8000/new/depense/achat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ...form,
        adminId: user._id
      })
    });

    if (!res.ok) return toast.error("Erreur enregistrement");

    toast.success("Dépense enregistrée");
    setForm({ type: "DEPENSE", categorie: "AUTRE", montant: "", description: "" });
    setShowAddModal(false);
    fetchData();
  };

  const confirmDelete = async () => {
    const res = await fetch(
      `http://localhost:8000/delete/depense/achat/${selected._id}`,
      { method: "DELETE" }
    );

    if (!res.ok) return toast.error("Erreur suppression");

    toast.success("Dépense supprimée");
    setShowDeleteModal(false);
    fetchData();
  };

  const formatMontant = (value) => {
  // s'assure que c'est un nombre entier
  const montant = Number(value) || 0;
  return montant.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

const exportPDF = () => {
  const doc = new jsPDF();

  const tableColumn = ["Date", "Type", "Catégorie", "Description", "Montant"];
  const tableRows = filteredList.map(d => [
    new Date(d.createdAt).toLocaleDateString(),
    d.type,
    d.categorie,
    d.description || "-",
    formatMontant(d.montant) + " FCFA"
  ]);

  doc.autoTable({
    head: [tableColumn],
    body: tableRows,
    startY: 20
  });

  doc.text("Liste des dépenses / achats", 14, 15);

  // 🔹 Date pour le nom du fichier
  const today = new Date();
  const dateStr = today.toLocaleDateString("fr-FR").replace(/\//g, "-"); // ex: 31-01-2026
  doc.save(`depenses_${dateStr}.pdf`);
};

const exportExcel = () => {
  const worksheet = XLSX.utils.json_to_sheet(
    filteredList.map(d => ({
      Date: new Date(d.createdAt).toLocaleDateString(),
      Type: d.type,
      Catégorie: d.categorie,
      Description: d.description || "-",
      Montant: d.montant
    }))
  );

  // Définir la largeur des colonnes
  worksheet['!cols'] = [
    { wch: 15 }, // Date
    { wch: 15 }, // Type
    { wch: 20 }, // Catégorie
    { wch: 40 }, // Description
    { wch: 15 }, // Montant
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Dépenses");

  // 🔹 Date pour le nom du fichier
  const today = new Date();
  const dateStr = today.toLocaleDateString("fr-FR").replace(/\//g, "-"); // ex: 31-01-2026
  XLSX.writeFile(workbook, `depenses_${dateStr}.xlsx`);
};

const printTable = () => {
  const printContent = document.querySelector(".card table").outerHTML;
  const WinPrint = window.open("", "", "width=900,height=650");
  WinPrint.document.write(`
    <html>
      <head>
        <title>Dépenses</title>
        <style>
          table { width:100%; border-collapse:collapse; }
          th, td { border:1px solid #000; padding:8px; text-align:left; }
        </style>
      </head>
      <body>
        <h3>Liste des dépenses / achats</h3>
        ${printContent}
      </body>
    </html>
  `);
  WinPrint.document.close();
  WinPrint.focus();
  WinPrint.print();
  WinPrint.close();
};



const printDepensePDF = (depense) => {
  const doc = new jsPDF();

  doc.setFontSize(16);
  doc.text("Reçu de dépense / achat", 14, 20);

  doc.setFontSize(12);
  doc.text(`Date : ${new Date(depense.createdAt).toLocaleDateString()}`, 14, 30);
  doc.text(`Type : ${depense.type}`, 14, 38);
  doc.text(`Catégorie : ${depense.categorie}`, 14, 46);
  doc.text(`Description : ${depense.description || "-"}`, 14, 54);

  const montantFormate = formatMontant(depense.montant);
  doc.text(`Montant : ${montantFormate} FCFA`, 14, 62);

  doc.save(`recu_depense_${depense._id}.pdf`);
};
  // KPIs
  const totalGlobal = list.reduce((s, d) => s + d.montant, 0);
  const now = new Date();
  const totalMonth = list
    .filter(d => {
      const date = new Date(d.createdAt);
      return date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
    })
    .reduce((s, d) => s + d.montant, 0);
  const totalFiltered = filteredList.reduce((s, d) => s + d.montant, 0);

  const start = (page - 1) * perPage;
  const paginatedList = filteredList.slice(start, start + perPage);
  const totalPages = Math.ceil(filteredList.length / perPage);

  return (
    <>
      <Navbar />

      <div className="page">
        <h2>🧾 Achats & Dépenses</h2>

         

        <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
                 <button className="btn-primary" onClick={() => setShowAddModal(true)}>
          ➕ Ajouter une dépense / achat
        </button>
  <button className="btn-primary" onClick={exportPDF}>📄 Export PDF</button>
  <button className="btn-primary" onClick={exportExcel}>📊 Export Excel</button>
</div>

        {/* ===== KPIs ===== */}
        <div className="card form-grid">
          <div>Total global : {totalGlobal.toLocaleString()} FCFA</div>
          <div>Total mois en cours ( {new Date().toLocaleString("fr-FR", { month: "long" })} ) : {totalMonth.toLocaleString()} FCFA</div>
          {/* <div>Total filtré : {totalFiltered.toLocaleString()} FCFA</div> */}
        </div>

        <div className="card form-grid">
          <h6>Filtrer par :</h6>
          <input type="date" value={from} onChange={e => setFrom(e.target.value)} />
          <input type="date" value={to} onChange={e => setTo(e.target.value)} />
          <button className="btn-primary" type="button" onClick={() => setPage(1)}>
            Filtrer
          </button>
        </div>

        <div className="card">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Type</th>
                <th>Catégorie</th>
                <th>description</th>
                <th>Montant</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedList.map(d => (
                <tr key={d._id}>
                  <td>{new Date(d.createdAt).toLocaleDateString()}</td>
                  <td>{d.type}</td>
                  <td>{d.categorie}</td>
                            <td>{d.description}</td>
                  <td className="amount">{d.montant.toLocaleString()} FCFA</td>
                 <td className="actions">
  <i className="fa-solid fa-pen-to-square edit" onClick={() => openEditModal(d)} />
  <i className="fa-solid fa-trash delete" onClick={() => openDeleteModal(d)} />
  <button
    className="btn-primary"
    style={{ marginLeft: "8px", padding: "4px 8px", fontSize: "0.8rem" }}
    onClick={() => printDepensePDF(d)}
  >
    🖨️ Reçu
  </button>
</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="pagination">
          <button disabled={page === 1} onClick={() => setPage(p => p - 1)}>◀</button>
          <span>Page {page} / {totalPages}</span>
          <button disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>▶</button>
        </div>
      </div>

      <Footer />

      {/* ===== MODAL AJOUT ===== */}
      {showAddModal && (
        <div className="modal-overlay-mode">
          <div className="modal-mode">
            <h3>➕ Nouvelle dépense / achat</h3>
            <form onSubmit={submit} className="form-grid">
              <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })}>
                <option value="DEPENSE">Dépense</option>
                <option value="ACHAT">Achat</option>
              </select>

              <select value={form.categorie} onChange={e => setForm({ ...form, categorie: e.target.value })}>
                <option value="STOCK">Stock</option>
                <option value="LOYER">Loyer</option>
                <option value="TRANSPORT">Transport</option>
                <option value="SALAIRE">Salaire</option>
                <option value="AUTRE">Autre</option>
              </select>

              <input
                type="number"
                placeholder="Montant"
                value={form.montant}
                onChange={e => setForm({ ...form, montant: e.target.value })}
                required
              />

              <input
                placeholder="Description"
                value={form.description}
                onChange={e => setForm({ ...form, description: e.target.value })}
              />

              <div className="modal-actions">
                <button type="button" onClick={() => setShowAddModal(false)}>Annuler</button>
                <button className="btn-primary">Enregistrer</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ===== MODAL EDIT ===== */}
      {showEditModal && (
        <div className="modal-overlay-mode">
          <div className="modal-mode">
            <h3>✏️ Modifier dépense</h3>
            <form onSubmit={handleUpdate} className="form-grid">
              <select value={editForm.type} onChange={e => setEditForm({ ...editForm, type: e.target.value })}>
                <option value="DEPENSE">Dépense</option>
                <option value="ACHAT">Achat</option>
              </select>

              <select value={editForm.categorie} onChange={e => setEditForm({ ...editForm, categorie: e.target.value })}>
                <option value="STOCK">Stock</option>
                <option value="LOYER">Loyer</option>
                <option value="TRANSPORT">Transport</option>
                <option value="SALAIRE">Salaire</option>
                <option value="AUTRE">Autre</option>
              </select>

              <input
                type="number"
                value={editForm.montant}
                onChange={e => setEditForm({ ...editForm, montant: e.target.value })}
                required
              />

              <input
                value={editForm.description}
                onChange={e => setEditForm({ ...editForm, description: e.target.value })}
              />

              <div className="modal-actions">
                <button type="button" onClick={() => setShowEditModal(false)}>Annuler</button>
                <button className="btn-primary">Mettre à jour</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ===== MODAL DELETE ===== */}
      {showDeleteModal && (
        <div className="modal-overlay-mode">
          <div className="modal-mode">
            <h3>🗑️ Suppression</h3>
            <p>Confirmer la suppression de cette dépense ?</p>
            <div className="modal-actions">
              <button onClick={() => setShowDeleteModal(false)}>Annuler</button>
              <button className="btn-danger" onClick={confirmDelete}>Supprimer</button>
            </div>
          </div>
        </div>
      )}

      {/* ===== CSS ===== */}
      <style>{`
        .page { padding:30px; background:#f5f7fb; min-height:100vh; }
        h2 { margin-bottom:20px; }
        .card { background:#fff; padding:20px; border-radius:14px; box-shadow:0 6px 18px rgba(0,0,0,0.08); margin-bottom:25px; }
        .form-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(200px,1fr)); gap:15px; align-items:center; }
        select,input { padding:10px 12px; border-radius:8px; border:1px solid #ddd; font-size:0.95rem; }
        select:focus,input:focus { outline:none; border-color:#4f46e5; }
        .btn-primary { background:#4f46e5; color:white; padding:10px; border-radius:10px; border:none; cursor:pointer; font-weight:600; transition: background 0.2s;margin-bottom:1rem }
        .btn-primary:hover { background:#4338ca; }
        table { width:100%; border-collapse:collapse; margin-top:15px; }
        th,td { padding:10px; border-bottom:1px solid #eee; text-align:left; }
        th { background:rgba(0,0,0,0.08); font-weight:600; }
        .amount { font-weight:600; }
        .actions i { margin-right:12px; cursor:pointer; font-size:1rem; }
        .actions .edit { color:#4f46e5; }
        .actions .delete { color:#dc2626; }
        .pagination { display:flex; justify-content:center; align-items:center; gap:15px; margin-top:15px; }
        .pagination button { padding:6px 12px; border-radius:8px; border:none; background:#4f46e5; color:white; cursor:pointer; }
        .pagination button:disabled { background:#ccc; cursor:not-allowed; }
        .modal-overlay-mode { position:fixed; inset:0; background:rgba(0,0,0,0.45); display:flex; align-items:center; justify-content:center; z-index:999; }
        .modal-mode { background:white; padding:25px; border-radius:14px; width:420px; max-width:95%; box-shadow:0 10px 30px rgba(0,0,0,0.2); }
        .modal h3 { margin-bottom:15px; }
        .modal-actions { display:flex; justify-content:flex-end; gap:10px; }
        .btn-danger { background:#dc2626; color:white; padding:10px; border-radius:10px; border:none; cursor:pointer; }
      `}</style>
    </>
  );
}